export default {"src":"/_next/static/media/volume.79102303.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};